import { memo } from "react";

import styled from "styled-components";

import { Finding } from "stores/FindingStore";

// -----------------------------------------------------------------------------

const BoxFindingDetailsUnknown = memo(function BoxFindingDetailsUnknown({
  finding,
}: BoxFindingDetailsUnknownProps) {
  return (
    <div>
      <JSONBox>{JSON.stringify(finding?.details || "No details.")}</JSONBox>
    </div>
  );
});

export default BoxFindingDetailsUnknown;

// -----------------------------------------------------------------------------

interface BoxFindingDetailsUnknownProps {
  finding: Finding;
}

// -----------------------------------------------------------------------------

const JSONBox = styled.pre`
  margin: 0;
  word-break: break-all;
  white-space: pre-wrap;
`;
